const testimonials = [
  {
    id: 1,
    name: 'Gaurav',
    title: 'App Developer',
    org: 'Triumb Technologies Private Limited',
    desc: 'Developed Triumb Ecommerce Full Stack Application',
  },
  {
    id: 2,
    name: 'Gaurav',
    title: 'Head of IT',
    org: 'Randomize();',
    desc:
      'Organiser of DSA Series Program at Randomize and Made Questions and Test Cases of Code Glitz 2.0 (Codeathon)',
  },
  {
    id: 3,
    name: 'Gaurav',
    title: 'App Dev Mentor',
    org: 'Randomize();',
    desc: 'Mentored Members of Club for Flutter',
  },
];
export default testimonials;
